// removed by extract-text-webpack-plugin
module.exports = {"Card":"Card---1qs36"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/shared/Card/styles.styl
// module id = y7ir
// module chunks = 89